import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { TableDataSpace } from 'modules/table';
import { Workorder } from 'modules/entities/modules/workorder-documents';
import { DocumentElevator } from '../../DocumentElevator';
import { DocumentsTable } from '../../DocumentsTable';
import ItemActions from '../../ItemActions';
import { useRouteMatch } from 'react-router-dom';

interface NotfallplanTableProps {
    loading: boolean;
    documents: Workorder[];
    isElevatorDetail?: boolean;
}

export const NotfallplanTable: React.FC<NotfallplanTableProps> = ({ loading, documents, isElevatorDetail }) => {
    const match = useRouteMatch('/elevators/:id');

    return (
        <DocumentsTable<Workorder>
            columns={[
                ...(match?.isExact
                    ? []
                    : [
                          {
                              key: 'elevator',
                              dataIndex: 'elevator',
                              width: '33%',
                              render: (_, { elevator }) => <DocumentElevator elevator={elevator} />,
                          },
                      ]),
                {
                    key: 'inspectionDate',
                    width: match?.isExact ? '50%' : '33%',
                    render: (_, { inspectionDate }) => (
                        <TableDataSpace
                            title={<FormattedMessage id="documents.table.documentDate" />}
                            value={<FormattedDate value={inspectionDate} />}
                        />
                    ),
                },
                {
                    key: 'documentType',
                    width: match?.isExact ? '50%' : '33%',
                    render: () => (
                        <TableDataSpace
                            title={<FormattedMessage id="documents.table.documentType" />}
                            value={<FormattedMessage id="documents.notfallplan.title" />}
                        />
                    ),
                },
                {
                    key: 'actions',
                    width: match?.isExact ? '50%' : '33%',
                    render: (_, { id, file }) => <ItemActions id={id} file={file} />,
                },
            ]}
            loading={loading}
            dataSource={documents}
            data-testid="notfallplan-table"
        />
    );
}; 